<template>
	<div
		class="px-4"
	>
		<div
			v-if="item.submenu"
			class="flex flex-col rounded overflow-hidden shadow-inner ring-1 ring-purple-400/5"
		>
			<button
				class="bg-purple-900/50 text-left px-6 py-2 flex justify-between items-center h-16"
				@click="isSubmenuOpen = !isSubmenuOpen"
			>
				<span class="text-functional-size-md">{{ item.text }}</span>
				<AtomFontAwesome
					class="size-6 transition-transform"
					:class="{
						'rotate-45': isSubmenuOpen,
					}"
					icon="fa-plus"
				/>
			</button>
			<SubMenu
				v-bind="item.submenu"
				:is-open="isSubmenuOpen"
				@navigate="emit('navigate')"
			/>
		</div>
		<AtomLink
			v-else
			class="shadow-inner ring-1 ring-purple-400/5 bg-purple-900/50 text-left px-6 py-2 flex justify-between items-center rounded h-16"
			v-bind="item.to"
			@click="emit('navigate')"
		>
			<span class="text-functional-size-md">
				{{ item.text }}
				<span
					v-if="counter"
					class="rounded-full size-8 bg-red-400 text-white text-center inline-flex items-center justify-center ml-4"
				>
					{{ counter }}
				</span>
			</span>
			<AtomFontAwesome
				class="size-5 transition-transform"
				icon="fa-chevron-right"
			/>
		</AtomLink>
	</div>
</template>

<script setup lang="ts">
import SubMenu from './SubMenu.vue';
import type { MainMenuItemType } from '#base/core/types/MainMenuItemType';

const {
	item,
} = defineProps<{
	item: MainMenuItemType;
}>();

const isSubmenuOpen = ref<boolean>(false);

const emit = defineEmits(['navigate']);

const counter = ref<number>();

onMounted(async () => {
	if (!item.counter) {
		return;
	}

	if (typeof item.counter === 'number') {
		counter.value = item.counter;

		return;
	}

	counter.value = await item.counter;
});
</script>
